const booking = {
  bookingInformation: "Πληροφορίες κράτησης", // translated
  ourCancellationPolicy: "Η Πολιτική Ακυρώσεων μας", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "Αυτό αντικαθιστά οποιαδήποτε πολιτική ακύρωσης στις παραπάνω παρατηρήσεις", // translated
  thisBookingIsNonNefundable: "Αυτή η κράτηση δεν επιστρέφεται", // translated
  paymentTerms: "Οροι πληρωμής", // translated
  paymentWillBeTakenFromYourDefault: "Η πληρωμή θα ληφθεί από την προεπιλογή σας", // translated
  paymentMethod: "μέθοδος πληρωμής", // translated
  afterTheFreeCancellationPeriodIfApplicable: "μετά τη δωρεάν περίοδο ακύρωσης εάν υπάρχει", // translated
  prebook: "Προβιβλίο", // translated
  guests: "Καλεσμένοι", // translated
  payment: "Πληρωμή", // translated
  byClicking: "Κάνοντας κλικ", // translated
  youAreAgreeingToOur: "συμφωνείτε με το δικό μας", // translated
  termsAndConditions: "Οροι και Προϋποθέσεις", // translated
  lastBookableDate: "Τελευταία ημερομηνία κράτησης", // translated
  customerRemarksTextfield: "Παρατηρήσεις πελατών", // translated
  request: "Αίτηση", // translated
};

export default booking;
